exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-card {\n  width: 160px;\n  height: 75px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.custom-title {\n  font-size: 14px;\n}\n.amount {\n  font-size: 38px;\n}\n.custom-text {\n  height: 45px;\n}\n", ""]);

// exports
